import { Icon } from "@mui/material";
import FlexBox from "./FlexBox";
import styled from "styled-components";
import { StyledText } from "./Text";
import { useContext } from "react";
import { SemesterContext } from "../context/SemesterContext";
interface Props {
  setSkillView: any;
  data: any;
}
export const CompetencyDetailOverview = (props: Props) => {
  const { data, setSkillView } = props;
  const Label = styled.h5`
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: left;
    width: 200px;
  `;
  const Ul = styled.ul`
    color: #d0d0d0;
    padding-inline-start: 16px;
    margin-block-start: 0;
    margin-block-end: 0;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: left;
  `;
  const semesterContext = useContext(SemesterContext);
  return (
    <div
      className="visible-scrollbar"
      style={{
        background: "rgba(171, 171, 171, 0.1)",
        borderRadius: 5,
        padding: 20,
        marginTop: 10,
        maxHeight: 280,
        overflow: "auto",
        position: "relative",
      }}
    >
      <FlexBox
        style={{
          position: "fixed",
          right: 40,
          color: "#ffda00",
          cursor: "pointer",
        }}
        onClick={() => setSkillView(true)}
      >
        View Skills
        <Icon>keyboard_double_arrow_right_icon</Icon>
      </FlexBox>
      <div style={{ display: "flex" }}>
        <Label style={{ marginBottom: 10 }}>Pillar</Label>:
        <StyledText style={{ color: "#d0d0d0", marginLeft: 10 }}>
          <Icon
            sx={{
              color: "rgba(0, 0, 0, 0.6)",
              mr: 1,
              padding: "4px",
              background: data.graphics.iconbg,
              boxShadow: data.graphics.iconshadow,
              borderRadius: "100px",
              fontSize: "16px",
              verticalAlign: "sub",
            }}
          >
            {data.graphics.icon}
          </Icon>
          {data.pillar_title}
        </StyledText>
      </div>
      <div style={{ display: "flex" }}>
        <Label style={{ marginBottom: 10 }}>Version</Label>:
        <StyledText style={{ color: "#d0d0d0", marginLeft: 10 }}>
          {data.display_version}
        </StyledText>
      </div>
      <div style={{ display: "flex" }}>
        <Label style={{ marginBottom: 10 }}>Version Status</Label>:
        <StyledText style={{ color: "#d0d0d0", marginLeft: 10 }}>
          {data.version_status}
        </StyledText>
      </div>{" "}
      <div style={{ display: "flex" }}>
        <Label style={{ marginBottom: 10 }}>Domain</Label>:
        <StyledText style={{ color: "#d0d0d0", marginLeft: 10 }}>
          {data.subdomain_title}
        </StyledText>
      </div>{" "}
      <div style={{ display: "flex" }}>
        <Label style={{ marginBottom: 10 }}>Start Week</Label>:
        <StyledText style={{ color: "#d0d0d0", marginLeft: 10 }}>
         {data.semester_detail.first_week? `Week ${data.semester_detail.first_week}`: "--"}
        </StyledText>
      </div>{" "}
      <div style={{ display: "flex" }}>
        <Label style={{ marginBottom: 10 }}>End Week</Label>:
        <StyledText style={{ color: "#d0d0d0", marginLeft: 10 }}>
          {data.semester_detail.last_week ? `Week ${data.semester_detail.last_week}` : "--"}
        </StyledText>
      </div>{" "}
      <div style={{ display: "flex" }}>
        <Label style={{ marginBottom: 10 }}>Day of Week</Label>:
        <StyledText style={{ color: "#d0d0d0", marginLeft: 10 }}>
          {data.semester_detail.weekday || "--"}
        </StyledText>
      </div>{" "}
      <div style={{ display: "flex" }}>
        <Label style={{ marginBottom: 10 }}>Start Time</Label>:
        <StyledText style={{ color: "#d0d0d0", marginLeft: 10 }}>
          {data.semester_detail.start_time  || "--"}
        </StyledText>
      </div>{" "}
      <div style={{ display: "flex" }}>
        <Label style={{ marginBottom: 10 }}>End Time</Label>:
        <StyledText style={{ color: "#d0d0d0", marginLeft: 10 }}>
          {data.semester_detail.end_time || "--"}
        </StyledText>
      </div>{" "}
      <div style={{ display: "flex" }}>
        <Label style={{ marginBottom: 10 }}>First Week</Label>:
        <StyledText style={{ color: "#d0d0d0", marginLeft: 10 }}>
          {(data.semester_detail.start_date.includes("UTC")
            ? data.semester_detail.start_date.split(" 00")[0]
            : data.semester_detail.start_date) ||
            semesterContext.selectedSemester.start_date}
        </StyledText>
      </div>{" "}
      <div style={{ display: "flex" }}>
        <Label style={{ marginBottom: 10 }}>Last Week</Label>:
        <StyledText style={{ color: "#d0d0d0", marginLeft: 10 }}>
          {(data.semester_detail.end_date.includes("UTC")
            ? data.semester_detail.end_date.split(" 00")[0]
            : data.semester_detail.end_date) ||
            semesterContext.selectedSemester.end_date}
        </StyledText>
      </div>{" "}
      <div style={{ display: "flex" }}>
        <Label style={{ marginBottom: 10 }}>Instructor</Label>:
        <StyledText style={{ color: "#d0d0d0", marginLeft: 10 }}>
          {(semesterContext.selectedSemester?.label !== "All"
            ? data.semester_detail.instructors
            : data.instructors) || "Unspecified"}
        </StyledText>
      </div>
      <div style={{ display: "flex" }}>
        <Label style={{ marginBottom: 10 }}>Credits</Label>:
        <StyledText style={{ color: "#d0d0d0", marginLeft: 10 }}>
          {data.credits}
        </StyledText>
        {data.required && (
          <StyledText style={{ color: "#d0d0d0" }}>-- REQUIRED</StyledText>
        )}
      </div>
      <div style={{ display: "flex" }}>
        <Label style={{ marginBottom: 10 }}>Prerequisites</Label>:
        <StyledText style={{ color: "#d0d0d0", marginLeft: 10 }}>
          {data.prerequisites && data.prerequisites.length > 0 ? (
            <Ul>
              {data.prerequisites.map((pre: any) => (
                <li>
                  <StyledText fontWeight="bold">
                    [{pre.competency_code || pre.prerequisite_competency_code}]
                  </StyledText>
                  <div>{pre.prerequisite_competency_title}</div>
                </li>
              ))}
            </Ul>
          ) : (
            <StyledText>-- None --</StyledText>
          )}
        </StyledText>
      </div>
      <div style={{ display: "flex" }}>
        <Label style={{ margin: 0 }}>Distribution Areas</Label>:
        {/* <StyledText style={{ color: "#d0d0d0", marginLeft: 10 }}> */}
        {data.area_map.core_technical ||
          data.area_map.math_science ||
          data.area_map.research ||
          data.area_map.social_communication_arts ||
          data.area_map.soft_skill ||
          data.area_map.xp ? (
          <Ul>
            {data.area_map.core_technical && (
              <li>
                <StyledText fontWeight="bold">Core Technical</StyledText>
              </li>
            )}
            {data.area_map.math_science && (
              <li>
                <StyledText fontWeight="bold">Math Science</StyledText>
              </li>
            )}
            {data.area_map.research && (
              <li>
                <StyledText fontWeight="bold">Research</StyledText>
              </li>
            )}
            {data.area_map.social_communication_arts && (
              <li>
                <StyledText fontWeight="bold">
                  {" "}
                  Social Communication Arts
                </StyledText>
              </li>
            )}
            {data.area_map.soft_skill && (
              <li>
                <StyledText fontWeight="bold">Soft Skill</StyledText>
              </li>
            )}
            {data.area_map.xp && (
              <li>
                <StyledText fontWeight="bold">XP</StyledText>
              </li>
            )}
          </Ul>
        ) : (
          <StyledText>-- None --</StyledText>
        )}
      </div>
    </div>
  );
};